
import './ToggleShowLastNote.scss'

import React from 'react'
import Switch from 'react-switch'
import { connect } from 'react-redux'
import { setShowLastNote } from 'manager/redux/referral_status'
import { ReferralNote } from 'manager/views/components/ReferralStatus/ReferralNote'

const Toggle = ({ checked, onChange, referral, title }) => {
    const lastATH = _.get(referral, ['assignment_transaction_history', 0], {})

    return (
        <div className="ToggleShowLastNote">
            <div className="ToggleShowLastNote__controls">
                <div className="ToggleShowLastNote__title">{title}</div>
                <label htmlFor="toggle-show-lastnote">
                    <span>Show last note</span>
                    <Switch
                        id="toggle-show-lastnote"
                        checkedIcon={false}
                        uncheckedIcon={false}
                        height={15}
                        width={30}
                        onColor="#0088DD"
                        onChange={onChange}
                        checked={checked}
                        />
                </label>
            </div>
            <div className="ToggleShowLastNote__note">
                {checked && (
                    <ReferralNote
                        created_at={lastATH.created_at}
                        is_lease={referral.is_lease}
                        transaction_type={referral.transaction_type}
                        transaction_status={lastATH.transaction_status}
                        note={lastATH.agent_note} />
                )}
            </div>
        </div>
    )
}

const selector = state => {
    const checked = _.get(state, ['referralStatus', 'showLastNote'], false)
    const referral = _.get(state, ['referral','referral'], {})

    return {
        checked,
        referral,
    }
}

const actions = {
    onChange: setShowLastNote
}

export const ToggleShowLastNote = connect(selector, actions)(Toggle)
